export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/wasm-module-2.8fb8cbb79c5f8202.js");
}
